<template>
    <q-card class="history-card" flat >
        <q-card-section class="history-container">
            <div>
                <div class="text-h5 q-mb-sm">{{formType}} History</div>
                <q-carousel v-if="formData && formData.length" v-model="slide" arrows navigation infinite animated transition-prev="slide-right"
                    transition-next="slide-left" control-color="primary"
                    class="history-carousel bg-grey-1 rounded-borders">
                    <q-carousel-slide v-for="(response, index) in formData" :name="index" :key="index"
                        class="history-slide scroll flex justify-center text-body1">
                        <div class="text-subtitle1 q-mb-sm text-weight-bold">
                            Response #{{ index + 1 }} - Submitted: {{ formatDate(response.submitted_time) }}
                        </div>

                        <div v-for="(section, domainKey) in groupByDomain(response)" :key="domainKey" class="history-section q-mb-md">
                            <div class="text-subtitle2 text-weight-medium q-mb-xs">
                                {{ domainLabels[domainKey] }}
                            </div>

                            <q-list bordered class="rounded-borders">
                                <q-item v-for="(item, name) in section" :key="name" class="q-px-sm q-py-xs">
                                    <q-item-section>
                                        <div class="row items-center justify-between q-gutter-sm">
                                            <div>{{ formatLabel(name) }}:</div>
                                            <div class="text-bold">
                                                <span v-if="item.type === 'rating'">{{ item.value }}</span>
                                                <span v-else>Section goal: {{ item.value || 'None' }}</span>
                                            </div>
                                        </div>
                                    </q-item-section>
                                </q-item>
                            </q-list>
                        </div>
                    </q-carousel-slide>
                </q-carousel>

                <div v-else-if="formData && formData.length === 0" class="q-pa-md text-center">
                    <q-icon name="info" size="50px" class="text-primary" />
                    <div class="text-h6 q-mt-sm">No form data available</div>
                </div>

                <div v-else>
                    <q-spinner />
                    <span class="q-ml-sm">Loading form data...</span>
                </div>
            </div>
        </q-card-section>
    </q-card>
</template>
  
<script>
import api from "../../../services/api/api";

export default {
    name: "FormHistoryResponseComponent",

    props: {
        client: {
            type: Object,
            required: true
        },
        formType: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            formData: null,
            slide: 0,
            domainLabels: {
                u: "Ūkaipō (Relationships)",
                h: "Hinengaro (Mental Health)",
                ti: "Tinana (Physical Health)",
                ta: "Taiao (Environment)",
                r: "Rawa (Resources)",
                w: "Wairua (Spiritual Wellbeing)"
            }
        };
    },

    async created() {
        await this.fetchFormData();
    },

    methods: {

        async fetchFormData() {
            try {
                const response = await api.forms.getTeitiKahurangiFormDataHistory(this.client?.client_id ?? null);
                this.formData = response.data.data;
            } catch (error) {
                console.error("Error fetching form data:", error);
            }
        },

        groupByDomain(response) {
            const labelMap = {
                ukaipo: 'u',
                hinengaro: 'h',
                tinana: 'ti',
                taiao: 'ta',
                rawa: 'r',
                wairua: 'w',
            };

            const groups = {
                u: {},
                h: {},
                ti: {},
                ta: {},
                r: {},
                w: {},
            };

            for (const [key, value] of Object.entries(response)) {
                const prefix = key.split("_")[0];

                // Check if it's one of our expected labels
                const shortKey = labelMap[prefix] || prefix;
                if (!groups[shortKey]) continue;

                let type = "";
                if (key.endsWith("_rating")) type = "rating";
                else if (key.endsWith("_goals")) type = "section_goal";

                if (type) {
                    groups[shortKey][key] = { value, type };
                }
            }
            return groups;
        },

        formatLabel(key) {
            return key
                .replace(/^[a-z]+_/, "")
                .replace(/_/g, " ")
                .replace(/\b\w/g, (l) => l.toUpperCase());
        },

        formatDate(dateStr) {
            const date = new Date(dateStr);
            return date.toLocaleString();
        }
    }
};
</script>

<style scoped>
.history-card {
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
}

.history-container {
    padding: 16px 20px 20px;
}

.history-carousel {
    min-height: 420px;
    height: 60vh;
    max-height: 720px;
}

.history-slide {
    padding: 8px 0 24px;
}

.history-section {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
}

@media (max-width: 600px) {
    .history-container {
        padding: 12px 12px 16px;
    }

    .history-carousel {
        height: 55vh;
        min-height: 360px;
    }
}
</style>
